import { render, staticRenderFns } from "./Objective.vue?vue&type=template&id=24da3889&scoped=true"
import script from "./Objective.vue?vue&type=script&lang=js"
export * from "./Objective.vue?vue&type=script&lang=js"
import style0 from "./Objective.vue?vue&type=style&index=0&id=24da3889&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24da3889",
  null
  
)

export default component.exports